import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import IconButton from '@mui/material/IconButton';

import SearchIcon from '@mui/icons-material/Search';

interface SearchInputProps {
  value?: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyPress?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  onSearchClick?: () => void;
  placeholder: string;
  ariaLabel?: string;
  cyid?: string;
}

const styles = {
  paper: {
    display: 'flex',
    alignItems: 'center',
    padding: '2px 4px',
  },
  inputBase: {
    marginLeft: 8,
    flex: 1,
  },
};

const SearchInput = ({
  value,
  onChange,
  onKeyPress,
  onSearchClick,
  placeholder,
  ariaLabel,
  cyid
}: SearchInputProps) => {
  return (
    <Box p={1}>
      <Paper style={styles.paper} elevation={1}>
        <InputBase
          name="query"
          style={styles.inputBase}
          placeholder={placeholder}
          {...(value !== undefined ? { value } : {})}
          onKeyPress={onKeyPress}
          onChange={onChange}
          autoFocus
          inputProps={cyid ? { cyid } : {}}
        />
        <IconButton
          onClick={onSearchClick}
          sx={{mr: 1 }}
          aria-label={ariaLabel}
          disabled={!onSearchClick}
        >
          <SearchIcon />
        </IconButton>
      </Paper>
    </Box>
  );
};

export default SearchInput;
